export default (props) => (
  <div
    lwc-1n142g6kutj=""
    class="slds-grid slds-wrap slds-col slds-size_1-of-1 row row-main slds-p-around_medium"
  >
    <div
      lwc-1n142g6kutj=""
      class="slds-col slds-large-size_8-of-12 slds-medium-size_8-of-12 slds-size_1-of-1 column region-main"
      style={{paddingInlineEnd: '8px'}}
    >
      <slot lwc-1n142g6kutj="" name="main">
        <div
          data-component-id="flexipage_tabset"
          data-target-selection-name="flexipage_tabset"
          slot="main"
          lwc-7uq5q81tcsp-host=""
        >
          <slot lwc-7uq5q81tcsp="">
            <div>
              <div class="slds-tabs_card">
                <h2 class="slds-assistive-text">Tabs</h2>
                <div class="flexipage-tabset" lwc-53k3k3g5nb9-host="">
                  <div lwc-53k3k3g5nb9="" class="slds-tabs_default">
                    <div
                      lwc-53k3k3g5nb9=""
                      exportparts="tab-bar, tab-item"
                      variant="standard"
                      lwc-72usf2nsemu-host=""
                    >
                      <ul
                        lwc-72usf2nsemu=""
                        class="slds-tabs_default__nav"
                        role="tablist"
                        aria-label="Tabs"
                        part="tab-bar"
                      >
                        <li
                          lwc-72usf2nsemu=""
                          class="slds-tabs_default__item slds-is-active"
                          data-tab=""
                          part="tab-item"
                          title="Activity"
                          role="presentation"
                          data-label="Activity"
                          data-tab-value="activityTab"
                          data-target-selection-name="activityTabTab"
                        >
                          <a
                            lwc-72usf2nsemu=""
                            class="slds-tabs_default__link"
                            data-tab-value="activityTab"
                            data-label="Activity"
                            role="tab"
                            href="javascript:void(0)"
                            tabindex="0"
                            aria-selected="true"
                            id="activityTab__item"
                            aria-controls="tab-2"
                          >
                            Activity
                          </a>
                        </li>
                        <li
                          lwc-72usf2nsemu=""
                          class="slds-tabs_default__item"
                          data-tab=""
                          part="tab-item"
                          title="Details"
                          role="presentation"
                          data-tab-value="detailTab"
                          data-target-selection-name="detailTabTab"
                          data-label="Details"
                        >
                          <a
                            lwc-72usf2nsemu=""
                            class="slds-tabs_default__link"
                            data-tab-value="detailTab"
                            role="tab"
                            href="javascript:void(0)"
                            tabindex="-1"
                            aria-selected="false"
                            id="detailTab__item"
                            aria-controls="tab-3"
                            data-label="Details"
                          >
                            Details
                          </a>
                        </li>
                        <li
                          lwc-72usf2nsemu=""
                          class="slds-tabs_default__item"
                          data-tab=""
                          part="tab-item"
                          title="Chatter"
                          role="presentation"
                          data-tab-value="collaborateTab"
                          data-target-selection-name="collaborateTabTab"
                          data-label="Chatter"
                        >
                          <a
                            lwc-72usf2nsemu=""
                            class="slds-tabs_default__link"
                            data-tab-value="collaborateTab"
                            role="tab"
                            href="javascript:void(0)"
                            tabindex="-1"
                            aria-selected="false"
                            id="collaborateTab__item"
                            aria-controls="tab-4"
                            data-label="Chatter"
                          >
                            Chatter
                          </a>
                        </li>
                        <li
                          lwc-72usf2nsemu=""
                          class="slds-tabs_default__item slds-tabs_default__overflow-button"
                          data-overflow=""
                          part="tab-item tab-overflow"
                        >
                          <div
                            lwc-72usf2nsemu=""
                            data-target-reveals=""
                            variant="bare"
                            icon-name="utility:chevrondown"
                            label="More"
                            class="slds-dropdown-trigger slds-dropdown-trigger_click"
                            lwc-1df1eblanv8-host=""
                          >
                            <button
                              lwc-1df1eblanv8=""
                              class="slds-button"
                              aria-expanded="false"
                              title="More Tabs"
                              value=""
                              aria-haspopup="true"
                              type="button"
                              part="button"
                            >
                              More
                              <span
                                lwc-1df1eblanv8=""
                                variant="bare"
                                lwc-7nohpd9g9ec-host=""
                              >
                                <svg
                                  focusable="false"
                                  aria-hidden="true"
                                  viewBox="0 0 520 520"
                                  part="icon"
                                  lwc-7nohpd9g9ec=""
                                  data-key="chevrondown"
                                  class="slds-button__icon slds-button__icon_right"
                                >
                                  <g lwc-7nohpd9g9ec="">
                                    <path
                                      d="M476 178L271 385c-6 6-16 6-22 0L44 178c-6-6-6-16 0-22l22-22c6-6 16-6 22 0l161 163c6 6 16 6 22 0l161-162c6-6 16-6 22 0l22 22c5 6 5 15 0 21z"
                                      lwc-7nohpd9g9ec=""
                                    ></path>
                                  </g>
                                </svg>
                              </span>
                              <span
                                class="slds-assistive-text"
                                lwc-1df1eblanv8=""
                              >
                                Tabs
                              </span>
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <slot lwc-53k3k3g5nb9="">
                      <slot name="tabs">
                        <div
                          slot="tabs"
                          role="tabpanel"
                          id="tab-2"
                          class="slds-tabs_default__content slds-show"
                          lwc-e181ppo4iq-host=""
                          aria-labelledby="activityTab__item"
                        >
                          <slot lwc-e181ppo4iq="">
                            <div
                              data-component-id="runtime_sales_activities_activityPanel"
                              data-target-selection-name="runtime_sales_activities_activityPanel"
                              lwc-7uq5q81tcsp-host=""
                            >
                              <div lwc-7uq5q81tcsp="">
                                <div>
                                  <div>
                                    <div
                                      class="slds-card-wrapper activityPanel"
                                      data-aura-rendered-by="1306:0"
                                    >
                                      <h2
                                        class="slds-assistive-text"
                                        data-aura-rendered-by="1307:0"
                                      >
                                        Activity Publisher
                                      </h2>
                                      <div
                                        class="slds-m-horizontal_xx-small"
                                        data-data-rendering-service-uid="358"
                                        data-aura-rendered-by="1310:0"
                                        lwc-75psssksh3b-host=""
                                      >
                                        <div
                                          lwc-75psssksh3b=""
                                          class="slds-m-vertical_xxx-small slds-button-group"
                                          data-target-selection-name="LogACallTab"
                                          role="group"
                                          lwc-60lfo2rbbbv-host=""
                                        >
                                          <div
                                            lwc-60lfo2rbbbv=""
                                            class="fix_button-group-flexbox"
                                            part="button-group"
                                          >
                                            <slot lwc-60lfo2rbbbv="">
                                              <button
                                                lwc-75psssksh3b=""
                                                class="slds-button slds-button_neutral"
                                                variant="border-filled"
                                                aria-label="Log a Call"
                                                value="LogACall"
                                                title="Log a Call"
                                              >
                                                <div
                                                  lwc-75psssksh3b=""
                                                  icon-name="standard:log_a_call"
                                                  class="slds-icon-standard-log-a-call slds-icon_container"
                                                  lwc-4897l11qtae-host=""
                                                >
                                                  <span
                                                    lwc-4897l11qtae=""
                                                    part="boundary"
                                                  >
                                                    <span
                                                      lwc-4897l11qtae=""
                                                      exportparts="icon"
                                                      size="small"
                                                      variant="inverse"
                                                      lwc-5t3lr8fubvi-host=""
                                                    >
                                                      <svg
                                                        focusable="false"
                                                        aria-hidden="true"
                                                        viewBox="0 0 1000 1000"
                                                        part="icon"
                                                        lwc-5t3lr8fubvi=""
                                                        data-key="log_a_call"
                                                        class="slds-icon slds-icon_small"
                                                      >
                                                        <g lwc-5t3lr8fubvi="">
                                                          <path
                                                            d="M697 200H321c-33 0-61 30-61 60v20h-20c-22 0-40 18-40 40s18 40 40 40h20v100h-20c-22 0-40 18-40 40s18 40 40 40h20v100h-20c-22 0-40 18-40 40s18 40 40 40h20v20c0 30 28 60 61 60h376c33 0 63-30 63-63V257c0-33-30-57-63-57zm-36 403l-28 28c-6 6-15 10-23 9a264 264 0 01-249-249c0-9 3-17 9-23l28-28c13-13 35-12 46 3l26 32c9 11 9 26 1 38l-22 31c-3 4-3 10 1 13l46 51 51 46c4 4 9 4 13 1l31-22c11-8 27-8 38 1l32 26c12 8 13 30 0 43z"
                                                            lwc-5t3lr8fubvi=""
                                                          ></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                    <span
                                                      class="slds-assistive-text"
                                                      lwc-4897l11qtae=""
                                                    >
                                                      Log a Call
                                                    </span>
                                                  </span>
                                                </div>
                                                <span
                                                  class="slds-text-align_right slds-p-left_x-small"
                                                  lwc-75psssksh3b=""
                                                  value="LogACall"
                                                >
                                                  Log a Call
                                                </span>
                                              </button>
                                              <div
                                                lwc-75psssksh3b=""
                                                variant="border-filled"
                                                class="slds-dropdown-trigger slds-dropdown-trigger_click"
                                                lwc-1df1eblanv8-host=""
                                              >
                                                <button
                                                  lwc-1df1eblanv8=""
                                                  class="slds-button slds-button_icon-border-filled fix-slds-button_icon-border-filled slds-button_last"
                                                  aria-expanded="false"
                                                  title="More Log a Call Actions"
                                                  value=""
                                                  aria-haspopup="true"
                                                  type="button"
                                                  part="button button-icon"
                                                >
                                                  <span
                                                    lwc-1df1eblanv8=""
                                                    variant="bare"
                                                    lwc-6qul4k2dv7m-host=""
                                                  >
                                                    <svg
                                                      focusable="false"
                                                      aria-hidden="true"
                                                      viewBox="0 0 520 520"
                                                      part="icon"
                                                      lwc-6qul4k2dv7m=""
                                                      data-key="down"
                                                      class="slds-button__icon"
                                                    >
                                                      <g lwc-6qul4k2dv7m="">
                                                        <path
                                                          d="M83 140h354c10 0 17 13 9 22L273 374c-6 8-19 8-25 0L73 162c-7-9-1-22 10-22z"
                                                          lwc-6qul4k2dv7m=""
                                                        ></path>
                                                      </g>
                                                    </svg>
                                                  </span>
                                                  <span
                                                    class="slds-assistive-text"
                                                    lwc-1df1eblanv8=""
                                                  >
                                                    More Log a Call Actions
                                                  </span>
                                                </button>
                                              </div>
                                            </slot>
                                          </div>
                                        </div>
                                        <div
                                          lwc-75psssksh3b=""
                                          class="slds-m-vertical_xxx-small slds-button-group"
                                          data-target-selection-name="NewTaskTab"
                                          role="group"
                                          lwc-60lfo2rbbbv-host=""
                                        >
                                          <div
                                            lwc-60lfo2rbbbv=""
                                            class="fix_button-group-flexbox"
                                            part="button-group"
                                          >
                                            <slot lwc-60lfo2rbbbv="">
                                              <button
                                                lwc-75psssksh3b=""
                                                class="slds-button slds-button_neutral"
                                                variant="border-filled"
                                                aria-label="New Task"
                                                value="NewTask"
                                                title="New Task"
                                              >
                                                <div
                                                  lwc-75psssksh3b=""
                                                  icon-name="standard:task"
                                                  class="slds-icon-standard-task slds-icon_container"
                                                  lwc-4897l11qtae-host=""
                                                >
                                                  <span
                                                    lwc-4897l11qtae=""
                                                    part="boundary"
                                                  >
                                                    <span
                                                      lwc-4897l11qtae=""
                                                      exportparts="icon"
                                                      size="small"
                                                      variant="inverse"
                                                      lwc-olk0r2te5h-host=""
                                                    >
                                                      <svg
                                                        focusable="false"
                                                        aria-hidden="true"
                                                        viewBox="0 0 1000 1000"
                                                        part="icon"
                                                        lwc-olk0r2te5h=""
                                                        data-key="task"
                                                        class="slds-icon slds-icon_small"
                                                      >
                                                        <g lwc-olk0r2te5h="">
                                                          <path
                                                            d="M466 237l-21-21c-6-6-15-6-21 0L292 348l-53-53c-6-6-15-6-21 0l-21 21c-6 6-6 15 0 21l74 74a29 29 0 0042 0l153-153c5-5 5-15 0-21zm304 143H510c-11 0-20-9-20-20v-40c0-11 9-20 20-20h260c11 0 20 9 20 20v40c0 11-9 20-20 20zm0 180H450c-11 0-20-9-20-20v-40c0-11 9-20 20-20h320c11 0 20 9 20 20v40c0 11-9 20-20 20zm-440 0h-40c-11 0-20-9-20-20v-40c0-11 9-20 20-20h40c11 0 20 9 20 20v40c0 11-9 20-20 20zm0 180h-40c-11 0-20-9-20-20v-40c0-11 9-20 20-20h40c11 0 20 9 20 20v40c0 11-9 20-20 20zm440 0H450c-11 0-20-9-20-20v-40c0-11 9-20 20-20h320c11 0 20 9 20 20v40c0 11-9 20-20 20z"
                                                            lwc-olk0r2te5h=""
                                                          ></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                    <span
                                                      class="slds-assistive-text"
                                                      lwc-4897l11qtae=""
                                                    >
                                                      New Task
                                                    </span>
                                                  </span>
                                                </div>
                                                <span
                                                  class="slds-text-align_right slds-p-left_x-small"
                                                  lwc-75psssksh3b=""
                                                  value="NewTask"
                                                >
                                                  New Task
                                                </span>
                                              </button>
                                              <div
                                                lwc-75psssksh3b=""
                                                variant="border-filled"
                                                class="slds-dropdown-trigger slds-dropdown-trigger_click"
                                                lwc-1df1eblanv8-host=""
                                              >
                                                <button
                                                  lwc-1df1eblanv8=""
                                                  class="slds-button slds-button_icon-border-filled fix-slds-button_icon-border-filled slds-button_last"
                                                  disabled=""
                                                  aria-expanded="false"
                                                  title="No Additional New Task Actions"
                                                  value=""
                                                  aria-haspopup="true"
                                                  type="button"
                                                  part="button button-icon"
                                                >
                                                  <span
                                                    lwc-1df1eblanv8=""
                                                    variant="bare"
                                                    lwc-6qul4k2dv7m-host=""
                                                  >
                                                    <svg
                                                      focusable="false"
                                                      aria-hidden="true"
                                                      viewBox="0 0 520 520"
                                                      part="icon"
                                                      lwc-6qul4k2dv7m=""
                                                      data-key="down"
                                                      class="slds-button__icon"
                                                    >
                                                      <g lwc-6qul4k2dv7m="">
                                                        <path
                                                          d="M83 140h354c10 0 17 13 9 22L273 374c-6 8-19 8-25 0L73 162c-7-9-1-22 10-22z"
                                                          lwc-6qul4k2dv7m=""
                                                        ></path>
                                                      </g>
                                                    </svg>
                                                  </span>
                                                  <span
                                                    class="slds-assistive-text"
                                                    lwc-1df1eblanv8=""
                                                  >
                                                    No Additional New Task
                                                    Actions
                                                  </span>
                                                </button>
                                              </div>
                                            </slot>
                                          </div>
                                        </div>
                                        <div
                                          lwc-75psssksh3b=""
                                          class="slds-m-vertical_xxx-small slds-button-group"
                                          data-target-selection-name="NewEventTab"
                                          role="group"
                                          lwc-60lfo2rbbbv-host=""
                                          style={{float: 'right'}}
                                        >
                                          <div
                                            lwc-60lfo2rbbbv=""
                                            class="fix_button-group-flexbox"
                                            part="button-group"
                                          >
                                            <slot lwc-60lfo2rbbbv="">
                                              {/* <button
                                                lwc-75psssksh3b=""
                                                class="slds-button slds-button_neutral"
                                                variant="border-filled"
                                                aria-label="New Event"
                                                value="NewEvent"
                                                title="New Event"
                                              >
                                                <div
                                                  lwc-75psssksh3b=""
                                                  icon-name="standard:event"
                                                  class="slds-icon-standard-event slds-icon_container"
                                                  lwc-4897l11qtae-host=""
                                                >
                                                  <span
                                                    lwc-4897l11qtae=""
                                                    part="boundary"
                                                  >
                                                    <span
                                                      lwc-4897l11qtae=""
                                                      exportparts="icon"
                                                      size="small"
                                                      variant="inverse"
                                                      lwc-5eng04crq1j-host=""
                                                    >
                                                      <svg
                                                        focusable="false"
                                                        aria-hidden="true"
                                                        viewBox="0 0 100 100"
                                                        part="icon"
                                                        lwc-5eng04crq1j=""
                                                        data-key="event"
                                                        class="slds-icon slds-icon_small"
                                                      >
                                                        <g lwc-5eng04crq1j="">
                                                          <path
                                                            d="M76 42H24a2 2 0 00-2 2v30a6 6 0 006 6h44a6 6 0 006-6V44a2 2 0 00-2-2zM40 70a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4c0-1.1.9-2 2-2h4a2 2 0 012 2zm0-14a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4c0-1.1.9-2 2-2h4a2 2 0 012 2zm14 14a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4c0-1.1.9-2 2-2h4a2 2 0 012 2zm0-14a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4c0-1.1.9-2 2-2h4a2 2 0 012 2zm14 14a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4c0-1.1.9-2 2-2h4a2 2 0 012 2zm0-14a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4c0-1.1.9-2 2-2h4a2 2 0 012 2zm4-30h-5v-2c0-2.2-1.8-4-4-4s-4 1.8-4 4v2H41v-2c0-2.2-1.8-4-4-4s-4 1.8-4 4v2h-5a6 6 0 00-6 6v2c0 1.1.9 2 2 2h52a2 2 0 002-2v-2a6 6 0 00-6-6z"
                                                            lwc-5eng04crq1j=""
                                                          ></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                    <span
                                                      class="slds-assistive-text"
                                                      lwc-4897l11qtae=""
                                                    >
                                                      New Event
                                                    </span>
                                                  </span>
                                                </div>
                                                <span
                                                  class="slds-text-align_right slds-p-left_x-small"
                                                  lwc-75psssksh3b=""
                                                  value="NewEvent"
                                                >
                                                  New Event
                                                </span>
                                              </button>
                                              <div
                                                lwc-75psssksh3b=""
                                                variant="border-filled"
                                                class="slds-dropdown-trigger slds-dropdown-trigger_click"
                                                lwc-1df1eblanv8-host=""
                                              >
                                                <button
                                                  lwc-1df1eblanv8=""
                                                  class="slds-button slds-button_icon-border-filled fix-slds-button_icon-border-filled slds-button_last"
                                                  aria-expanded="false"
                                                  title="More New Event Actions"
                                                  value=""
                                                  aria-haspopup="true"
                                                  type="button"
                                                  part="button button-icon"
                                                >
                                                  <span
                                                    lwc-1df1eblanv8=""
                                                    variant="bare"
                                                    lwc-6qul4k2dv7m-host=""
                                                  >
                                                    <svg
                                                      focusable="false"
                                                      aria-hidden="true"
                                                      viewBox="0 0 520 520"
                                                      part="icon"
                                                      lwc-6qul4k2dv7m=""
                                                      data-key="down"
                                                      class="slds-button__icon"
                                                    >
                                                      <g lwc-6qul4k2dv7m="">
                                                        <path
                                                          d="M83 140h354c10 0 17 13 9 22L273 374c-6 8-19 8-25 0L73 162c-7-9-1-22 10-22z"
                                                          lwc-6qul4k2dv7m=""
                                                        ></path>
                                                      </g>
                                                    </svg>
                                                  </span>
                                                  <span
                                                    class="slds-assistive-text"
                                                    lwc-1df1eblanv8=""
                                                  >
                                                    More New Event Actions
                                                  </span>
                                                </button>
                                              </div> */}
                                              <span class="slds-theme_success slds-badge">Success<span class="slds-badge__icon slds-badge__icon_right"><span class="slds-icon_container slds-current-color"><lightning-primitive-icon size="xx-small"><svg class="slds-icon slds-icon-text-default slds-icon_xx-small" focusable="false" data-key="success" aria-hidden="true" viewBox="0 0 520 520" part="icon"><g><path d="M260 20a240 240 0 100 480 240 240 0 100-480zm134 180L241 355c-6 6-16 6-22 0l-84-85c-6-6-6-16 0-22l22-22c6-6 16-6 22 0l44 45a10 10 0 0015 0l112-116c6-6 16-6 22 0l22 22c7 6 7 16 0 23z"></path></g></svg></lightning-primitive-icon></span></span></span>
                                            </slot>
                                          </div>
                                        </div>
                                        <div
                                          lwc-75psssksh3b=""
                                          class="slds-m-vertical_xxx-small slds-button-group"
                                          data-target-selection-name="SendAnEmailTab"
                                          role="group"
                                          lwc-60lfo2rbbbv-host=""
                                          style={{float: 'right'}}
                                        >
                                          <div
                                            lwc-60lfo2rbbbv=""
                                            class="fix_button-group-flexbox"
                                            part="button-group"
                                          >
                                            <slot lwc-60lfo2rbbbv="">
                                              {/* <button
                                                lwc-75psssksh3b=""
                                                class="slds-button slds-button_neutral"
                                                variant="border-filled"
                                                aria-label="Email"
                                                value="SendEmail"
                                                title="Email"
                                              >
                                                <div
                                                  lwc-75psssksh3b=""
                                                  icon-name="standard:email"
                                                  class="slds-icon-standard-email slds-icon_container"
                                                  lwc-4897l11qtae-host=""
                                                >
                                                  <span
                                                    lwc-4897l11qtae=""
                                                    part="boundary"
                                                  >
                                                    <span
                                                      lwc-4897l11qtae=""
                                                      exportparts="icon"
                                                      size="small"
                                                      variant="inverse"
                                                      lwc-3so6tp9ge4e-host=""
                                                    >
                                                      <svg
                                                        focusable="false"
                                                        aria-hidden="true"
                                                        viewBox="0 0 1000 1000"
                                                        part="icon"
                                                        lwc-3so6tp9ge4e=""
                                                        data-key="email"
                                                        class="slds-icon slds-icon_small"
                                                      >
                                                        <g lwc-3so6tp9ge4e="">
                                                          <path
                                                            d="M487 550c8 7 19 7 27 0l283-262c5-10 4-26-16-26l-560 1c-15 0-27 14-16 26zm313-150c0-13-16-20-25-11L555 593c-15 14-34 21-54 21s-39-7-54-21L226 389a15 15 0 00-25 11v260c0 33 27 60 60 60h480c33 0 60-27 60-60z"
                                                            lwc-3so6tp9ge4e=""
                                                          ></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                    <span
                                                      class="slds-assistive-text"
                                                      lwc-4897l11qtae=""
                                                    >
                                                      Email
                                                    </span>
                                                  </span>
                                                </div>
                                                <span
                                                  class="slds-text-align_right slds-p-left_x-small"
                                                  lwc-75psssksh3b=""
                                                  value="SendEmail"
                                                >
                                                  Email
                                                </span>
                                              </button>
                                              <div
                                                lwc-75psssksh3b=""
                                                variant="border-filled"
                                                class="slds-dropdown-trigger slds-dropdown-trigger_click"
                                                lwc-1df1eblanv8-host=""
                                              >
                                                <button
                                                  lwc-1df1eblanv8=""
                                                  class="slds-button slds-button_icon-border-filled fix-slds-button_icon-border-filled slds-button_last"
                                                  aria-expanded="false"
                                                  title="More Email Actions"
                                                  value=""
                                                  aria-haspopup="true"
                                                  type="button"
                                                  part="button button-icon"
                                                >
                                                  <span
                                                    lwc-1df1eblanv8=""
                                                    variant="bare"
                                                    lwc-6qul4k2dv7m-host=""
                                                  >
                                                    <svg
                                                      focusable="false"
                                                      aria-hidden="true"
                                                      viewBox="0 0 520 520"
                                                      part="icon"
                                                      lwc-6qul4k2dv7m=""
                                                      data-key="down"
                                                      class="slds-button__icon"
                                                    >
                                                      <g lwc-6qul4k2dv7m="">
                                                        <path
                                                          d="M83 140h354c10 0 17 13 9 22L273 374c-6 8-19 8-25 0L73 162c-7-9-1-22 10-22z"
                                                          lwc-6qul4k2dv7m=""
                                                        ></path>
                                                      </g>
                                                    </svg>
                                                  </span>
                                                  <span
                                                    class="slds-assistive-text"
                                                    lwc-1df1eblanv8=""
                                                  >
                                                    More Email Actions
                                                  </span>
                                                </button>
                                              </div> */}
                                              <span class="slds-theme_error slds-badge">Error<span class="slds-badge__icon slds-badge__icon_right"><span class="slds-icon_container slds-current-color"><lightning-primitive-icon size="xx-small"><svg class="slds-icon slds-icon-text-default slds-icon_xx-small" focusable="false" data-key="error" aria-hidden="true" viewBox="0 0 520 520" part="icon"><g><path d="M260 20C128 20 20 128 20 260s108 240 240 240 240-108 240-240S392 20 260 20zM80 260a180 180 0 01284-147L113 364a176 176 0 01-33-104zm180 180c-39 0-75-12-104-33l251-251a180 180 0 01-147 284z"></path></g></svg></lightning-primitive-icon></span></span></span>
                                            </slot>
                                          </div>
                                        </div>
                                        <div
                                          lwc-75psssksh3b=""
                                          class="slds-m-vertical_xxx-small slds-button-group"
                                          data-target-selection-name="SendAnEmailTab"
                                          role="group"
                                          lwc-60lfo2rbbbv-host=""
                                          style={{float: 'right'}}
                                        >
                                          <div
                                            lwc-60lfo2rbbbv=""
                                            class="fix_button-group-flexbox"
                                            part="button-group"
                                          >
                                            <slot lwc-60lfo2rbbbv="">
                                              <span class="slds-theme_warning slds-badge">Warning<span class="slds-badge__icon slds-badge__icon_right"><span class="slds-icon_container slds-current-color"><lightning-primitive-icon size="xx-small"><svg class="slds-icon slds-icon-text-default slds-icon_xx-small" focusable="false" data-key="warning" aria-hidden="true" viewBox="0 0 520 520" part="icon"><g><path d="M514 425L285 55a28 28 0 00-50 0L6 425c-14 23 0 55 25 55h458c25 0 40-32 25-55zm-254-25c-17 0-30-13-30-30s13-30 30-30 30 13 30 30-13 30-30 30zm30-90c0 6-4 10-10 10h-40c-6 0-10-4-10-10V180c0-6 4-10 10-10h40c6 0 10 4 10 10v130z"></path></g></svg></lightning-primitive-icon></span></span></span>
                                            </slot>
                                          </div>
                                        </div>
                                      </div>
                                      <h2
                                        class="slds-assistive-text"
                                        data-aura-rendered-by="1311:0"
                                      >
                                        Activity Timeline
                                      </h2>

                                      <div
                                        class="MEDIUM grouped runtime_sales_activitiesActivityTimelineFixedLayout"
                                        data-aura-rendered-by="1319:0"
                                        data-aura-class="runtime_sales_activitiesActivityTimelineFixedLayout"
                                      >
                                        <div
                                          class="skip-timeline-wrapper slds-p-top_none slds-is-relative"
                                          data-aura-rendered-by="1323:0"
                                        >
                                          <a
                                            class="slds-assistive-text slds-assistive-text_focus skipTimeline forceSkipLink"
                                            data-aura-rendered-by="4:1719;a"
                                            href="javascript:void(0);"
                                            data-aura-class="forceSkipLink"
                                          >
                                            Skip to the bottom of the activity
                                            timeline
                                          </a>
                                          <div
                                            class="timelineError"
                                            data-aura-rendered-by="1325:0"
                                          ></div>
                                          <div
                                            class="slds-grid slds-wrap slds-grid_align-spread slds-grid_vertical-align-center slds-m-bottom_small"
                                            data-aura-rendered-by="1329:0"
                                          >
                                            <div
                                              class="slds-col columnWidth"
                                              data-aura-rendered-by="1330:0"
                                            ></div>
                                            <div
                                              class="slds-col columnWidth slds-grid slds-grid_align-end"
                                              data-aura-rendered-by="1332:0"
                                            >
                                              <span
                                                class="slds-truncate"
                                                data-aura-rendered-by="1333:0"
                                              >
                                                <div
                                                  class="selectedFiltersText slds-show_inline-block"
                                                  data-aura-rendered-by="1334:0"
                                                  lwc-f6gbo863ml-host=""
                                                >
                                                  Filters: All time • All
                                                  activities • All types
                                                </div>
                                              </span>
                                              <button
                                                aria-haspopup="true"
                                                type="button"
                                                title="Timeline Settings"
                                                class="slds-button slds-button_icon filterMenuLink slds-m-left_small slds-button_icon-border"
                                                data-aura-rendered-by="1338:0"
                                              >
                                                <span
                                                  variant="bare"
                                                  data-aura-rendered-by="1339:0"
                                                  lwc-31cpu082oko-host=""
                                                >
                                                  <svg
                                                    focusable="false"
                                                    aria-hidden="true"
                                                    viewBox="0 0 520 520"
                                                    part="icon"
                                                    lwc-31cpu082oko=""
                                                    data-key="settings"
                                                    class="slds-button__icon"
                                                  >
                                                    <g lwc-31cpu082oko="">
                                                      <path
                                                        d="M261 191c-39 0-70 31-70 70s31 70 70 70 70-31 70-70-31-70-70-70zm210 133l-37-31a195 195 0 000-68l37-31c12-10 16-28 8-42l-16-28a34 34 0 00-40-14l-46 17a168 168 0 00-59-34l-8-47c-3-16-17-25-33-25h-32c-16 0-30 9-33 25l-8 46a180 180 0 00-60 34l-46-17-11-2c-12 0-23 6-29 16l-16 28c-8 14-5 32 8 42l37 31a195 195 0 000 68l-37 31a34 34 0 00-8 42l16 28a34 34 0 0040 14l46-17c18 16 38 27 59 34l8 48a33 33 0 0033 27h32c16 0 30-12 33-28l8-48a170 170 0 0062-37l43 17 12 2c12 0 23-6 29-16l15-26c9-11 5-29-7-39zm-210 47c-61 0-110-49-110-110s49-110 110-110 110 49 110 110-49 110-110 110z"
                                                        lwc-31cpu082oko=""
                                                      ></path>
                                                    </g>
                                                  </svg>
                                                </span>
                                                <span
                                                  class="slds-assistive-text"
                                                  data-aura-rendered-by="1341:0"
                                                >
                                                  Timeline Settings
                                                </span>
                                              </button>
                                            </div>
                                          </div>
                                          <div
                                            class="slds-section slds-is-open slds-var-p-top_xx-small slds-var-p-bottom_x-small"
                                            data-aura-rendered-by="1343:0"
                                          >
                                            <div
                                              class="slds-section__title slds-button-section__title slds-m-bottom_x-small"
                                              data-aura-rendered-by="1344:0"
                                            >
                                              <div
                                                class="slds-section__title-action slds-p-around_none"
                                                data-aura-rendered-by="1345:0"
                                              ></div>
                                            </div>
                                            <div
                                              class="slds-button-section__buttons slds-text-align_center slds-var-m-bottom_x-small slds-is-relative slds-float_right"
                                              data-aura-rendered-by="1346:0"
                                              style={{
                                                marginTop:
                                                  "calc(-1 * var(--lwc-spacingLarge,1.5rem))",
                                              }}
                                            >
                                              <button
                                                type="button"
                                                title="Refresh"
                                                class="slds-button testonly-refreshTimeline slds-p-horizontal_xx-small"
                                                data-aura-rendered-by="1349:0"
                                              ></button>
                                              <span data-aura-rendered-by="1354:0">
                                                {" "}
                                                Refresh{" "}
                                              </span>
                                              <button
                                                type="button"
                                                title="Expand All"
                                                class="slds-button testonly-expandAll slds-p-horizontal_xx-small"
                                                data-aura-rendered-by="1358:0"
                                              ></button>
                                              <span data-aura-rendered-by="26:1719;a">
                                                {" "}
                                                Expand All{" "}
                                              </span>
                                              <a
                                                role="link"
                                                href="/runtime_sales_activities/activityViewAll.app?parentRecordId=006QZ000002nOL0YAM"
                                                title="Show all past activities in a new tab"
                                                class="slds-button slds-p-horizontal_xx-small"
                                                target="_blank"
                                                data-aura-rendered-by="28:1719;a"
                                              >
                                                View All
                                              </a>
                                            </div>
                                          </div>

                                          <div
                                            class="standardTimelineUpcomingActivities"
                                            data-aura-rendered-by="1366:0"
                                          >
                                            <div
                                              class="slds-section open-activity-group openActivities slds-is-open"
                                              data-aura-rendered-by="1367:0"
                                            >
                                              <h3
                                                class="openActivitiesHeader slds-section__title"
                                                data-aura-rendered-by="1369:0"
                                                style={{
                                                  fontSize:
                                                    "var(--slds-g-font-size-base, var(--lwc-fontSize3, 0.8125rem))",
                                                  fontWeight:
                                                    "var(--slds-g-font-weight-7, var(--lwc-fontWeightBold, 700))",
                                                }}
                                              >
                                                <button
                                                  aria-controls="upcoming-activities-section-006QZ000002nOL0YAM"
                                                  aria-expanded="true"
                                                  type="button"
                                                  title="Upcoming &amp; Overdue"
                                                  name="upcoming"
                                                  class="slds-button slds-section__title-action"
                                                  data-aura-rendered-by="1373:0"
                                                >
                                                  <span
                                                    variant="bare"
                                                    data-data-rendering-service-uid="432"
                                                    data-aura-rendered-by="1375:0"
                                                    lwc-7nohpd9g9ec-host=""
                                                  >
                                                    <svg
                                                      focusable="false"
                                                      aria-hidden="true"
                                                      viewBox="0 0 520 520"
                                                      part="icon"
                                                      lwc-7nohpd9g9ec=""
                                                      data-key="chevrondown"
                                                      class="slds-button__icon slds-button__icon_left"
                                                    >
                                                      <g lwc-7nohpd9g9ec="">
                                                        <path
                                                          d="M476 178L271 385c-6 6-16 6-22 0L44 178c-6-6-6-16 0-22l22-22c6-6 16-6 22 0l161 163c6 6 16 6 22 0l161-162c6-6 16-6 22 0l22 22c5 6 5 15 0 21z"
                                                          lwc-7nohpd9g9ec=""
                                                        ></path>
                                                      </g>
                                                    </svg>
                                                  </span>
                                                  Upcoming & Overdue
                                                </button>
                                              </h3>
                                              <div
                                                aria-hidden="false"
                                                id="upcoming-activities-section-006QZ000002nOL0YAM"
                                                class="slds-section__content "
                                                data-aura-rendered-by="1379:0"
                                              >
                                                <div
                                                  class=""
                                                  data-aura-rendered-by="1380:0"
                                                >
                                                  <ul data-aura-rendered-by="1382:0"></ul>
                                                </div>
                                                <div
                                                  class="slds-text-align_center emptyListContent"
                                                  data-aura-rendered-by="1686:0"
                                                >
                                                  <div
                                                    data-aura-rendered-by="1687:0"
                                                    class="slds-rich-text-editor__output"
                                                    lwc-4nfn2rc40ch-host=""
                                                  >
                                                    <span
                                                      lwc-4nfn2rc40ch=""
                                                      part="formatted-rich-text"
                                                    >
                                                      No activities to show. Get
                                                      started by sending an
                                                      email, scheduling a task,
                                                      and more.
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            class="past-activity-groups pastActivities activityHistories"
                                            data-aura-rendered-by="1690:0"
                                          >
                                            <div
                                              class=""
                                              data-aura-rendered-by="1691:0"
                                            >
                                              <div
                                                aria-hidden="false"
                                                id="past-activities-section-006QZ000002nOL0YAM"
                                                class=""
                                                data-aura-rendered-by="1693:0"
                                              >
                                                <div
                                                  class=""
                                                  data-aura-rendered-by="1694:0"
                                                ></div>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            role="status"
                                            class="emptyPastActivities slds-border_top slds-p-top_medium slds-m-top_medium slds-text-align_center"
                                            data-aura-rendered-by="30:1719;a"
                                          >
                                            <div
                                              data-aura-rendered-by="31:1719;a"
                                              class="slds-rich-text-editor__output"
                                              lwc-4nfn2rc40ch-host=""
                                            >
                                              <span
                                                lwc-4nfn2rc40ch=""
                                                part="formatted-rich-text"
                                              >
                                                No past activity. Past meetings
                                                and tasks marked as done show up
                                                here.
                                              </span>
                                            </div>
                                          </div>

                                          <div
                                            class="inlineSpinnerWrapper"
                                            data-aura-rendered-by="7:1719;a"
                                          >
                                            <div
                                              role="alert"
                                              aria-hidden="true"
                                              class="slds-is-absolute slds-var-p-left_large inlineSpinner indicator  hideEl forceInlineSpinner"
                                              data-aura-rendered-by="10:1719;a"
                                              data-aura-class="forceInlineSpinner"
                                            ></div>
                                          </div>
                                          <a
                                            class="slds-assistive-text slds-assistive-text_focus skip-timeline-endpoint forceSkipLink"
                                            data-aura-rendered-by="24:1719;a"
                                            href="javascript:void(0);"
                                            data-aura-class="forceSkipLink"
                                          >
                                            Skip to the top of the activity
                                            timeline
                                          </a>
                                        </div>
                                        <div
                                          class="timeline-end"
                                          data-aura-rendered-by="1709:0"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </slot>
                        </div>
                        <div
                          slot="tabs"
                          role="tabpanel"
                          id="tab-3"
                          class="slds-tabs_default__content slds-hide"
                          lwc-e181ppo4iq-host=""
                          aria-labelledby="detailTab__item"
                        ></div>
                        <div
                          slot="tabs"
                          role="tabpanel"
                          id="tab-4"
                          class="slds-tabs_default__content slds-hide"
                          lwc-e181ppo4iq-host=""
                          aria-labelledby="collaborateTab__item"
                        ></div>
                      </slot>
                    </slot>
                  </div>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </slot>
    </div>
    <div
      lwc-1n142g6kutj=""
      class="slds-col slds-large-size_4-of-12 slds-medium-size_4-of-12 slds-size_1-of-1 column region-sidebar-right"
      style={{paddingInlineStart: '8px'}}
    >
      <slot lwc-1n142g6kutj="" name="sidebar">
        <div
          data-component-id="flexipage_sidebar_tabset"
          data-target-selection-name="flexipage_sidebar_tabset"
          slot="sidebar"
          lwc-7uq5q81tcsp-host=""
        >
          <slot lwc-7uq5q81tcsp="">
            <div>
              <div class="slds-tabs_card">
                <h2 class="slds-assistive-text">Tabs</h2>
                <div class="flexipage-tabset" lwc-53k3k3g5nb9-host="">
                  <div lwc-53k3k3g5nb9="" class="slds-tabs_default">
                    <div
                      lwc-53k3k3g5nb9=""
                      exportparts="tab-bar, tab-item"
                      variant="standard"
                      lwc-72usf2nsemu-host=""
                    >
                      <ul
                        lwc-72usf2nsemu=""
                        class="slds-tabs_default__nav"
                        role="tablist"
                        aria-label="Tabs"
                        part="tab-bar"
                      >
                        <li
                          lwc-72usf2nsemu=""
                          class="slds-tabs_default__item slds-is-active"
                          data-tab=""
                          part="tab-item"
                          title="Related"
                          role="presentation"
                          data-tab-value="relatedListTab"
                          data-target-selection-name="relatedListTabTab"
                          data-label="Related"
                        >
                          <a
                            lwc-72usf2nsemu=""
                            class="slds-tabs_default__link"
                            data-tab-value="relatedListTab"
                            role="tab"
                            href="javascript:void(0)"
                            tabindex="0"
                            aria-selected="true"
                            id="relatedListTab__item"
                            aria-controls="tab-5"
                            data-label="Related"
                          >
                            Related
                          </a>
                        </li>
                        <li
                          lwc-72usf2nsemu=""
                          class="slds-tabs_default__item slds-tabs_default__overflow-button"
                          data-overflow=""
                          part="tab-item tab-overflow"
                        >
                          <div
                            lwc-72usf2nsemu=""
                            data-target-reveals=""
                            variant="bare"
                            icon-name="utility:chevrondown"
                            label="More"
                            class="slds-dropdown-trigger slds-dropdown-trigger_click"
                            lwc-1df1eblanv8-host=""
                          >
                            <button
                              lwc-1df1eblanv8=""
                              class="slds-button"
                              aria-expanded="false"
                              title="More Tabs"
                              value=""
                              aria-haspopup="true"
                              type="button"
                              part="button"
                            >
                              More
                              <span
                                lwc-1df1eblanv8=""
                                variant="bare"
                                lwc-7nohpd9g9ec-host=""
                              >
                                <svg
                                  focusable="false"
                                  aria-hidden="true"
                                  viewBox="0 0 520 520"
                                  part="icon"
                                  lwc-7nohpd9g9ec=""
                                  data-key="chevrondown"
                                  class="slds-button__icon slds-button__icon_right"
                                >
                                  <g lwc-7nohpd9g9ec="">
                                    <path
                                      d="M476 178L271 385c-6 6-16 6-22 0L44 178c-6-6-6-16 0-22l22-22c6-6 16-6 22 0l161 163c6 6 16 6 22 0l161-162c6-6 16-6 22 0l22 22c5 6 5 15 0 21z"
                                      lwc-7nohpd9g9ec=""
                                    ></path>
                                  </g>
                                </svg>
                              </span>
                              <span
                                class="slds-assistive-text"
                                lwc-1df1eblanv8=""
                              >
                                Tabs
                              </span>
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <slot lwc-53k3k3g5nb9="">
                      <slot name="tabs">
                        <div
                          slot="tabs"
                          role="tabpanel"
                          id="tab-5"
                          class="slds-tabs_default__content slds-show"
                          lwc-e181ppo4iq-host=""
                          aria-labelledby="relatedListTab__item"
                        >
                          <slot lwc-e181ppo4iq="">
                            <div
                              data-component-id="force_relatedListContainer"
                              data-target-selection-name="force_relatedListContainer"
                              lwc-7uq5q81tcsp-host=""
                            >
                              <slot lwc-7uq5q81tcsp="">
                                <div lwc-77en8vud2tf-host="">
                                  <div lwc-77en8vud2tf="" class="container">
                                    <div lwc-77en8vud2tf="" class="listWrapper">
                                      <div
                                        lwc-77en8vud2tf=""
                                        lwc-1km0t387tm6-host=""
                                      >
                                        <div
                                          lwc-1km0t387tm6=""
                                          aria-busy="false"
                                          lwc-7ir4frst5a7-host=""
                                        >
                                          <slot lwc-7ir4frst5a7="">
                                            <div lwc-1km0t387tm6="">
                                              <div
                                                data-this-triggers-rerenders="[object Object]"
                                                class=""
                                              >
                                                <div
                                                  class="container forceRelatedListSingleContainer"
                                                  data-aura-rendered-by="1763:0"
                                                  data-aura-class="forceRelatedListSingleContainer"
                                                >
                                                  <article
                                                    class="slds-card slds-card_boundary slds-card_related-list-fix forceRelatedListCardDesktop"
                                                    aria-label="Contact Roles"
                                                    data-aura-rendered-by="1825:0"
                                                    data-aura-class="forceRelatedListCardDesktop"
                                                  >
                                                    <div
                                                      class="slds-grid slds-page-header forceRelatedListCardHeader"
                                                      data-aura-rendered-by="1833:0"
                                                      data-aura-class="forceRelatedListCardHeader"
                                                    >
                                                      <header
                                                        class="slds-media slds-media--center slds-has-flexi-truncate"
                                                        data-aura-rendered-by="1834:0"
                                                      >
                                                        <div
                                                          aria-hidden="true"
                                                          class="slds-m-right_small stencil slds-avatar slds-avatar_small"
                                                          data-aura-rendered-by="1835:0"
                                                        >
                                                          <div
                                                            class="extraSmall forceEntityIcon"
                                                            style={{
                                                              background:
                                                                "#5867E8",
                                                            }}
                                                            data-aura-rendered-by="5:1843;a"
                                                            data-aura-class="forceEntityIcon"
                                                          >
                                                            <span
                                                              data-aura-rendered-by="8:1843;a"
                                                              class="uiImage"
                                                              data-aura-class="uiImage"
                                                            >
                                                              <img
                                                                data-aura-rendered-by="6:1843;a"
                                                                src="/icons/standard/opportunity_120.png"
                                                                class="icon "
                                                                alt=""
                                                              />
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div
                                                          class="slds-media__body"
                                                          data-aura-rendered-by="1836:0"
                                                        >
                                                          <h2
                                                            id="header_1817:0"
                                                            class="slds-card__header-title"
                                                            data-aura-rendered-by="1837:0"
                                                          >
                                                            <a
                                                              href="#"
                                                              class="slds-card__header-link baseCard__header-title-container"
                                                              data-aura-rendered-by="1838:0"
                                                            >
                                                              <span
                                                                title="Contact Roles"
                                                                class="slds-truncate slds-m-right--xx-small"
                                                                data-aura-rendered-by="1839:0"
                                                              >
                                                                Contact Roles
                                                              </span>
                                                              <span
                                                                title="(0)"
                                                                class="slds-shrink-none slds-m-right--xx-small"
                                                                data-aura-rendered-by="1842:0"
                                                              >
                                                                (0)
                                                              </span>
                                                            </a>
                                                          </h2>
                                                        </div>
                                                      </header>
                                                      <div
                                                        class="slds-no-flex"
                                                        data-aura-rendered-by="1845:0"
                                                      >
                                                        <div
                                                          class="actionsContainer"
                                                          data-aura-rendered-by="1827:0"
                                                        >
                                                          <ul
                                                            class="small oneActionsRibbon forceActionsContainer forceDeferredDropDownAction"
                                                            data-aura-rendered-by="2511:0"
                                                            data-aura-class="oneActionsRibbon forceActionsContainer forceDeferredDropDownAction"
                                                          >
                                                            <li
                                                              data-target-reveals="sfdc:StandardButton.OpportunityContactRole.OppContactRoleMultiAdd,sfdc:StandardButton.OpportunityContactRole.OppContactRoleMultiEdit"
                                                              class="oneActionsDropDown"
                                                              data-aura-rendered-by="2537:0"
                                                              data-aura-class="oneActionsDropDown"
                                                            >
                                                              <div
                                                                data-aura-rendered-by="2572:0"
                                                                class="uiMenu"
                                                                data-aura-class="uiMenu"
                                                              >
                                                                <div
                                                                  id="2539:0"
                                                                  data-aura-rendered-by="2550:0"
                                                                  class="uiPopupTrigger"
                                                                  data-aura-class="uiPopupTrigger"
                                                                  data-interactive-uid="2"
                                                                >
                                                                  <div
                                                                    data-aura-rendered-by="2552:0"
                                                                    data-proxy-id="aura-pos-lib-1"
                                                                    id="2552:0"
                                                                  >
                                                                    <div data-aura-rendered-by="2545:0">
                                                                      <a
                                                                        role="button"
                                                                        aria-haspopup="true"
                                                                        class="slds-button slds-button_icon-small slds-button_icon-border-filled"
                                                                        data-aura-rendered-by="1876:0"
                                                                        href="javascript:void(0);"
                                                                      >
                                                                        <div
                                                                          icon-name="utility:down"
                                                                          class="slds-icon-utility-down slds-icon_container"
                                                                          data-aura-rendered-by="1877:0"
                                                                          lwc-4897l11qtae-host=""
                                                                        >
                                                                          <span
                                                                            lwc-4897l11qtae=""
                                                                            part="boundary"
                                                                          >
                                                                            <span
                                                                              lwc-4897l11qtae=""
                                                                              exportparts="icon"
                                                                              size="xx-small"
                                                                              variant=""
                                                                              lwc-6qul4k2dv7m-host=""
                                                                            >
                                                                              <svg
                                                                                focusable="false"
                                                                                aria-hidden="true"
                                                                                viewBox="0 0 520 520"
                                                                                part="icon"
                                                                                lwc-6qul4k2dv7m=""
                                                                                data-key="down"
                                                                                class="slds-icon slds-icon-text-default slds-icon_xx-small"
                                                                              >
                                                                                <g lwc-6qul4k2dv7m="">
                                                                                  <path
                                                                                    d="M83 140h354c10 0 17 13 9 22L273 374c-6 8-19 8-25 0L73 162c-7-9-1-22 10-22z"
                                                                                    lwc-6qul4k2dv7m=""
                                                                                  ></path>
                                                                                </g>
                                                                              </svg>
                                                                            </span>
                                                                            <span
                                                                              class="slds-assistive-text"
                                                                              lwc-4897l11qtae=""
                                                                            >
                                                                              Show
                                                                              actions
                                                                              for
                                                                              Partners
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div data-aura-rendered-by="1850:0">
                                                      <div
                                                        class=""
                                                        data-aura-rendered-by="1851:0"
                                                      >
                                                        <div
                                                          class="previewMode SMALL forceRelatedListPreview"
                                                          data-aura-rendered-by="1854:0"
                                                          data-aura-class="forceRelatedListPreview"
                                                        >
                                                          <div
                                                            data-aura-rendered-by="1856:0"
                                                            class="hide"
                                                          >
                                                            <div
                                                              class="slds-card__body"
                                                              data-aura-rendered-by="1859:0"
                                                            >
                                                              <div
                                                                class="slds-hide"
                                                                data-aura-rendered-by="1862:0"
                                                              >
                                                                <div
                                                                  data-aura-rendered-by="1863:0"
                                                                  lwc-4auqus00epa-host=""
                                                                >
                                                                  <div
                                                                    class="slds-p-around_xxx-small"
                                                                    lwc-4auqus00epa=""
                                                                  >
                                                                    <div
                                                                      class="field"
                                                                      lwc-4auqus00epa=""
                                                                    >
                                                                      <div
                                                                        class="text text-primary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                      <div
                                                                        class="text text-secondary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                    </div>
                                                                    <div
                                                                      class="field"
                                                                      lwc-4auqus00epa=""
                                                                    >
                                                                      <div
                                                                        class="text text-primary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                      <div
                                                                        class="text text-secondary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <ul
                                                                class="uiAbstractList"
                                                                data-aura-rendered-by="2:1840;a"
                                                              ></ul>
                                                              <div
                                                                class="emptyContent hidden"
                                                                data-aura-rendered-by="1865:0"
                                                              >
                                                                <div
                                                                  class="emptyContentInner slds-text-align_center slds-text-align--center"
                                                                  data-aura-rendered-by="1866:0"
                                                                ></div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </article>
                                                </div>
                                              </div>
                                            </div>
                                          </slot>
                                        </div>
                                      </div>
                                    </div>
                                    <div lwc-77en8vud2tf="" class="listWrapper">
                                      <div
                                        lwc-77en8vud2tf=""
                                        lwc-1km0t387tm6-host=""
                                      >
                                        <div
                                          lwc-1km0t387tm6=""
                                          aria-busy="false"
                                          lwc-7ir4frst5a7-host=""
                                        >
                                          <slot lwc-7ir4frst5a7="">
                                            <div lwc-1km0t387tm6="">
                                              <div
                                                data-this-triggers-rerenders="[object Object]"
                                                class=""
                                              >
                                                <div
                                                  class="container forceRelatedListSingleContainer"
                                                  data-aura-rendered-by="1753:0"
                                                  data-aura-class="forceRelatedListSingleContainer"
                                                >
                                                  <article
                                                    class="slds-card slds-card_boundary slds-card_related-list-fix forceRelatedListCardDesktop"
                                                    aria-label="Partners"
                                                    data-aura-rendered-by="1774:0"
                                                    data-aura-class="forceRelatedListCardDesktop"
                                                  >
                                                    <div
                                                      class="slds-grid slds-page-header forceRelatedListCardHeader"
                                                      data-aura-rendered-by="1782:0"
                                                      data-aura-class="forceRelatedListCardHeader"
                                                    >
                                                      <header
                                                        class="slds-media slds-media--center slds-has-flexi-truncate"
                                                        data-aura-rendered-by="1783:0"
                                                      >
                                                        <div
                                                          aria-hidden="true"
                                                          class="slds-m-right_small stencil slds-avatar slds-avatar_small"
                                                          data-aura-rendered-by="1784:0"
                                                        >
                                                          <div
                                                            class="extraSmall forceEntityIcon"
                                                            data-aura-rendered-by="13:1843;a"
                                                            data-aura-class="forceEntityIcon"
                                                            style={{
                                                              background:
                                                                "#06a59a",
                                                            }}
                                                          >
                                                            <span
                                                              data-aura-rendered-by="16:1843;a"
                                                              class="uiImage"
                                                              data-aura-class="uiImage"
                                                            >
                                                              <img
                                                                data-aura-rendered-by="14:1843;a"
                                                                src="https://orgfarm-e404f0b48a.test2.my.pc-rnd.salesforce.com/img/icon/t4v35/standard/account_partner_120.png"
                                                                class="icon "
                                                                alt=""
                                                              />
                                                              <img
                                                                data-aura-rendered-by="24061:0"
                                                                src="/icons/standard/partners_120.png"
                                                                class="icon "
                                                                alt=""
                                                              />
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div
                                                          class="slds-media__body"
                                                          data-aura-rendered-by="1785:0"
                                                        >
                                                          <h2
                                                            id="header_1766:0"
                                                            class="slds-card__header-title"
                                                            data-aura-rendered-by="1786:0"
                                                          >
                                                            <a
                                                              href="/lightning/r/Opportunity/006QZ000002nOL0YAM/related/OpportunityPartnersFrom/view"
                                                              class="slds-card__header-link baseCard__header-title-container"
                                                              data-aura-rendered-by="1787:0"
                                                            >
                                                              <span
                                                                title="Partners"
                                                                class="slds-truncate slds-m-right--xx-small"
                                                                data-aura-rendered-by="1788:0"
                                                              >
                                                                Partners
                                                              </span>
                                                              <span
                                                                title="(0)"
                                                                class="slds-shrink-none slds-m-right--xx-small"
                                                                data-aura-rendered-by="1791:0"
                                                              >
                                                                (0)
                                                              </span>
                                                            </a>
                                                          </h2>
                                                        </div>
                                                      </header>
                                                      <div
                                                        class="slds-no-flex"
                                                        data-aura-rendered-by="1794:0"
                                                      >
                                                        <div
                                                          class="actionsContainer"
                                                          data-aura-rendered-by="1776:0"
                                                        >
                                                          <div
                                                            class="slds-float--right forceDeferredDropDownAction"
                                                            data-aura-rendered-by="1875:0"
                                                            data-aura-class="forceDeferredDropDownAction"
                                                          >
                                                            <a
                                                              role="button"
                                                              aria-haspopup="true"
                                                              class="slds-button slds-button_icon-small slds-button_icon-border-filled"
                                                              data-aura-rendered-by="1876:0"
                                                              href="javascript:void(0);"
                                                            >
                                                              <div
                                                                icon-name="utility:down"
                                                                class="slds-icon-utility-down slds-icon_container"
                                                                data-aura-rendered-by="1877:0"
                                                                lwc-4897l11qtae-host=""
                                                              >
                                                                <span
                                                                  lwc-4897l11qtae=""
                                                                  part="boundary"
                                                                >
                                                                  <span
                                                                    lwc-4897l11qtae=""
                                                                    exportparts="icon"
                                                                    size="xx-small"
                                                                    variant=""
                                                                    lwc-6qul4k2dv7m-host=""
                                                                  >
                                                                    <svg
                                                                      focusable="false"
                                                                      aria-hidden="true"
                                                                      viewBox="0 0 520 520"
                                                                      part="icon"
                                                                      lwc-6qul4k2dv7m=""
                                                                      data-key="down"
                                                                      class="slds-icon slds-icon-text-default slds-icon_xx-small"
                                                                    >
                                                                      <g lwc-6qul4k2dv7m="">
                                                                        <path
                                                                          d="M83 140h354c10 0 17 13 9 22L273 374c-6 8-19 8-25 0L73 162c-7-9-1-22 10-22z"
                                                                          lwc-6qul4k2dv7m=""
                                                                        ></path>
                                                                      </g>
                                                                    </svg>
                                                                  </span>
                                                                  <span
                                                                    class="slds-assistive-text"
                                                                    lwc-4897l11qtae=""
                                                                  >
                                                                    Show actions
                                                                    for Partners
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </a>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div data-aura-rendered-by="1799:0">
                                                      <div
                                                        class=""
                                                        data-aura-rendered-by="1800:0"
                                                      >
                                                        <div
                                                          class="previewMode SMALL forceRelatedListPreview"
                                                          data-aura-rendered-by="1803:0"
                                                          data-aura-class="forceRelatedListPreview"
                                                        >
                                                          <div
                                                            data-aura-rendered-by="1805:0"
                                                            class="hide"
                                                          >
                                                            <div
                                                              class="slds-card__body"
                                                              data-aura-rendered-by="1808:0"
                                                            >
                                                              <div
                                                                class="slds-hide"
                                                                data-aura-rendered-by="1811:0"
                                                              >
                                                                <div
                                                                  data-aura-rendered-by="1812:0"
                                                                  lwc-4auqus00epa-host=""
                                                                >
                                                                  <div
                                                                    class="slds-p-around_xxx-small"
                                                                    lwc-4auqus00epa=""
                                                                  >
                                                                    <div
                                                                      class="field"
                                                                      lwc-4auqus00epa=""
                                                                    >
                                                                      <div
                                                                        class="text text-primary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                      <div
                                                                        class="text text-secondary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                    </div>
                                                                    <div
                                                                      class="field"
                                                                      lwc-4auqus00epa=""
                                                                    >
                                                                      <div
                                                                        class="text text-primary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                      <div
                                                                        class="text text-secondary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <ul
                                                                class="uiAbstractList"
                                                                data-aura-rendered-by="2:1817;a"
                                                              ></ul>
                                                              <div
                                                                class="emptyContent hidden"
                                                                data-aura-rendered-by="1814:0"
                                                              >
                                                                <div
                                                                  class="emptyContentInner slds-text-align_center slds-text-align--center"
                                                                  data-aura-rendered-by="1815:0"
                                                                ></div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </article>
                                                </div>
                                              </div>
                                            </div>
                                          </slot>
                                        </div>
                                      </div>
                                    </div>
                                    <div lwc-77en8vud2tf="" class="listWrapper">
                                      <div
                                        lwc-77en8vud2tf=""
                                        lwc-1km0t387tm6-host=""
                                      >
                                        <div
                                          lwc-1km0t387tm6=""
                                          aria-busy="false"
                                          lwc-7ir4frst5a7-host=""
                                        >
                                          <slot lwc-7ir4frst5a7="">
                                            <div lwc-1km0t387tm6="">
                                              <div
                                                data-this-triggers-rerenders="[object Object]"
                                                class=""
                                              >
                                                <div
                                                  class="container forceRelatedListSingleContainer"
                                                  data-aura-rendered-by="2167:0"
                                                  data-aura-class="forceRelatedListSingleContainer"
                                                >
                                                  <article
                                                    class="slds-card slds-card_boundary slds-card_related-list-fix forceRelatedListCardDesktop"
                                                    aria-label="Products"
                                                    data-aura-rendered-by="2188:0"
                                                    data-aura-class="forceRelatedListCardDesktop"
                                                  >
                                                    <div
                                                      class="slds-grid slds-page-header forceRelatedListCardHeader"
                                                      data-aura-rendered-by="2196:0"
                                                      data-aura-class="forceRelatedListCardHeader"
                                                    >
                                                      <header
                                                        class="slds-media slds-media--center slds-has-flexi-truncate"
                                                        data-aura-rendered-by="2197:0"
                                                      >
                                                        <div
                                                          aria-hidden="true"
                                                          class="slds-m-right_small stencil slds-avatar slds-avatar_small"
                                                          data-aura-rendered-by="2198:0"
                                                        >
                                                          <div
                                                            class="extraSmall forceEntityIcon"
                                                            style={{
                                                              background:
                                                                "#FF5D2D",
                                                            }}
                                                            data-aura-rendered-by="5:2130;a"
                                                            data-aura-class="forceEntityIcon"
                                                          >
                                                            <span
                                                              data-aura-rendered-by="8:2130;a"
                                                              class="uiImage"
                                                              data-aura-class="uiImage"
                                                            >
                                                              <img
                                                                data-aura-rendered-by="2406:0"
                                                                src="/icons/standard/product_120.png"
                                                                class="icon "
                                                                alt=""
                                                              />
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div
                                                          class="slds-media__body"
                                                          data-aura-rendered-by="2199:0"
                                                        >
                                                          <h2
                                                            id="header_2180:0"
                                                            class="slds-card__header-title"
                                                            data-aura-rendered-by="2200:0"
                                                          >
                                                            <a
                                                              href="/lightning/r/Opportunity/006QZ000002nOL0YAM/related/OpportunityLineItems/view"
                                                              class="slds-card__header-link baseCard__header-title-container"
                                                              data-aura-rendered-by="2201:0"
                                                            >
                                                              <span
                                                                title="Products"
                                                                class="slds-truncate slds-m-right--xx-small"
                                                                data-aura-rendered-by="2202:0"
                                                              >
                                                                Products
                                                              </span>
                                                              <span
                                                                title="(0)"
                                                                class="slds-shrink-none slds-m-right--xx-small"
                                                                data-aura-rendered-by="2205:0"
                                                              >
                                                                (0)
                                                              </span>
                                                            </a>
                                                          </h2>
                                                        </div>
                                                      </header>
                                                      <div
                                                        class="slds-no-flex"
                                                        data-aura-rendered-by="2208:0"
                                                      >
                                                        <div
                                                          class="actionsContainer"
                                                          data-aura-rendered-by="2190:0"
                                                        >
                                                          <div
                                                            class="slds-float--right forceDeferredDropDownAction"
                                                            data-aura-rendered-by="2299:0"
                                                            data-aura-class="forceDeferredDropDownAction"
                                                          >
                                                            <a
                                                              role="button"
                                                              aria-haspopup="true"
                                                              class="slds-button slds-button_icon-small slds-button_icon-border-filled"
                                                              data-aura-rendered-by="2300:0"
                                                              href="javascript:void(0);"
                                                            >
                                                              <div
                                                                icon-name="utility:down"
                                                                class="slds-icon-utility-down slds-icon_container"
                                                                data-aura-rendered-by="2301:0"
                                                                lwc-4897l11qtae-host=""
                                                              >
                                                                <span
                                                                  lwc-4897l11qtae=""
                                                                  part="boundary"
                                                                >
                                                                  <span
                                                                    lwc-4897l11qtae=""
                                                                    exportparts="icon"
                                                                    size="xx-small"
                                                                    variant=""
                                                                    lwc-6qul4k2dv7m-host=""
                                                                  >
                                                                    <svg
                                                                      focusable="false"
                                                                      aria-hidden="true"
                                                                      viewBox="0 0 520 520"
                                                                      part="icon"
                                                                      lwc-6qul4k2dv7m=""
                                                                      data-key="down"
                                                                      class="slds-icon slds-icon-text-default slds-icon_xx-small"
                                                                    >
                                                                      <g lwc-6qul4k2dv7m="">
                                                                        <path
                                                                          d="M83 140h354c10 0 17 13 9 22L273 374c-6 8-19 8-25 0L73 162c-7-9-1-22 10-22z"
                                                                          lwc-6qul4k2dv7m=""
                                                                        ></path>
                                                                      </g>
                                                                    </svg>
                                                                  </span>
                                                                  <span
                                                                    class="slds-assistive-text"
                                                                    lwc-4897l11qtae=""
                                                                  >
                                                                    Show actions
                                                                    for Products
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </a>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div data-aura-rendered-by="2213:0">
                                                      <div
                                                        class=""
                                                        data-aura-rendered-by="2214:0"
                                                      >
                                                        <div
                                                          class="previewMode SMALL forceRelatedListPreview"
                                                          data-aura-rendered-by="2217:0"
                                                          data-aura-class="forceRelatedListPreview"
                                                        >
                                                          <div
                                                            data-aura-rendered-by="2219:0"
                                                            class="hide"
                                                          >
                                                            <div
                                                              class="slds-card__body"
                                                              data-aura-rendered-by="2222:0"
                                                            >
                                                              <div
                                                                class="slds-hide"
                                                                data-aura-rendered-by="2225:0"
                                                              >
                                                                <div
                                                                  data-aura-rendered-by="2226:0"
                                                                  lwc-4auqus00epa-host=""
                                                                >
                                                                  <div
                                                                    class="slds-p-around_xxx-small"
                                                                    lwc-4auqus00epa=""
                                                                  >
                                                                    <div
                                                                      class="field"
                                                                      lwc-4auqus00epa=""
                                                                    >
                                                                      <div
                                                                        class="text text-primary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                      <div
                                                                        class="text text-secondary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                    </div>
                                                                    <div
                                                                      class="field"
                                                                      lwc-4auqus00epa=""
                                                                    >
                                                                      <div
                                                                        class="text text-primary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                      <div
                                                                        class="text text-secondary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <ul
                                                                class="uiAbstractList"
                                                                data-aura-rendered-by="2:2100;a"
                                                              ></ul>
                                                              <div
                                                                class="emptyContent hidden"
                                                                data-aura-rendered-by="2228:0"
                                                              >
                                                                <div
                                                                  class="emptyContentInner slds-text-align_center slds-text-align--center"
                                                                  data-aura-rendered-by="2229:0"
                                                                ></div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </article>
                                                </div>
                                              </div>
                                            </div>
                                          </slot>
                                        </div>
                                      </div>
                                    </div>
                                    <div lwc-77en8vud2tf="" class="listWrapper">
                                      <div
                                        lwc-77en8vud2tf=""
                                        lwc-1km0t387tm6-host=""
                                      >
                                        <div
                                          lwc-1km0t387tm6=""
                                          aria-busy="false"
                                          lwc-7ir4frst5a7-host=""
                                        >
                                          <slot lwc-7ir4frst5a7="">
                                            <div lwc-1km0t387tm6="">
                                              <div
                                                data-this-triggers-rerenders="[object Object]"
                                                class=""
                                              >
                                                <div
                                                  class="container forceRelatedListSingleContainer"
                                                  data-aura-rendered-by="2177:0"
                                                  data-aura-class="forceRelatedListSingleContainer"
                                                >
                                                  <article
                                                    class="slds-card slds-card_boundary slds-card_related-list-fix forceRelatedListCardDesktop"
                                                    aria-label="Notes &amp; Attachments"
                                                    data-aura-rendered-by="2239:0"
                                                    data-aura-class="forceRelatedListCardDesktop"
                                                  >
                                                    <div
                                                      class="slds-grid slds-page-header forceRelatedListCardHeader"
                                                      data-aura-rendered-by="2247:0"
                                                      data-aura-class="forceRelatedListCardHeader"
                                                    >
                                                      <header
                                                        class="slds-media slds-media--center slds-has-flexi-truncate"
                                                        data-aura-rendered-by="2248:0"
                                                      >
                                                        <div
                                                          aria-hidden="true"
                                                          class="slds-m-right_small stencil slds-avatar slds-avatar_small"
                                                          data-aura-rendered-by="2249:0"
                                                        >
                                                          <div
                                                            class="extraSmall forceEntityIcon"
                                                            style={{
                                                              background:
                                                                "#939393",
                                                            }}
                                                            data-aura-rendered-by="13:2130;a"
                                                            data-aura-class="forceEntityIcon"
                                                          >
                                                            <span
                                                              data-aura-rendered-by="16:2130;a"
                                                              class="uiImage"
                                                              data-aura-class="uiImage"
                                                            >
                                                              <img
                                                                data-aura-rendered-by="2406:0"
                                                                src="/icons/standard/file_120.png"
                                                                class="icon "
                                                                alt=""
                                                              />
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div
                                                          class="slds-media__body"
                                                          data-aura-rendered-by="2250:0"
                                                        >
                                                          <h2
                                                            id="header_2231:0"
                                                            class="slds-card__header-title"
                                                            data-aura-rendered-by="2251:0"
                                                          >
                                                            <a
                                                              href="/lightning/r/Opportunity/006QZ000002nOL0YAM/related/CombinedAttachments/view"
                                                              class="slds-card__header-link baseCard__header-title-container"
                                                              data-aura-rendered-by="2252:0"
                                                            >
                                                              <span
                                                                title="Notes &amp; Attachments"
                                                                class="slds-truncate slds-m-right--xx-small"
                                                                data-aura-rendered-by="2253:0"
                                                              >
                                                                Notes &amp;
                                                                Attachments
                                                              </span>
                                                              <span
                                                                title="(0)"
                                                                class="slds-shrink-none slds-m-right--xx-small"
                                                                data-aura-rendered-by="2256:0"
                                                              >
                                                                (0)
                                                              </span>
                                                            </a>
                                                          </h2>
                                                        </div>
                                                      </header>
                                                      <div
                                                        class="slds-no-flex"
                                                        data-aura-rendered-by="2259:0"
                                                      >
                                                        <div
                                                          class="actionsContainer"
                                                          data-aura-rendered-by="2241:0"
                                                        >
                                                          <div
                                                            class="slds-float--right forceDeferredDropDownAction"
                                                            data-aura-rendered-by="2310:0"
                                                            data-aura-class="forceDeferredDropDownAction"
                                                          >
                                                            <a
                                                              role="button"
                                                              aria-haspopup="true"
                                                              class="slds-button slds-button_icon-small slds-button_icon-border-filled"
                                                              data-aura-rendered-by="2311:0"
                                                              href="javascript:void(0);"
                                                            >
                                                              <div
                                                                icon-name="utility:down"
                                                                class="slds-icon-utility-down slds-icon_container"
                                                                data-aura-rendered-by="2312:0"
                                                                lwc-4897l11qtae-host=""
                                                              >
                                                                <span
                                                                  lwc-4897l11qtae=""
                                                                  part="boundary"
                                                                >
                                                                  <span
                                                                    lwc-4897l11qtae=""
                                                                    exportparts="icon"
                                                                    size="xx-small"
                                                                    variant=""
                                                                    lwc-6qul4k2dv7m-host=""
                                                                  >
                                                                    <svg
                                                                      focusable="false"
                                                                      aria-hidden="true"
                                                                      viewBox="0 0 520 520"
                                                                      part="icon"
                                                                      lwc-6qul4k2dv7m=""
                                                                      data-key="down"
                                                                      class="slds-icon slds-icon-text-default slds-icon_xx-small"
                                                                    >
                                                                      <g lwc-6qul4k2dv7m="">
                                                                        <path
                                                                          d="M83 140h354c10 0 17 13 9 22L273 374c-6 8-19 8-25 0L73 162c-7-9-1-22 10-22z"
                                                                          lwc-6qul4k2dv7m=""
                                                                        ></path>
                                                                      </g>
                                                                    </svg>
                                                                  </span>
                                                                  <span
                                                                    class="slds-assistive-text"
                                                                    lwc-4897l11qtae=""
                                                                  >
                                                                    Show actions
                                                                    for Notes
                                                                    &amp;
                                                                    Attachments
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </a>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div data-aura-rendered-by="2264:0">
                                                      <div
                                                        class=""
                                                        data-aura-rendered-by="2265:0"
                                                      >
                                                        <div
                                                          class="previewMode SMALL forceRelatedListPreview"
                                                          data-aura-rendered-by="2268:0"
                                                          data-aura-class="forceRelatedListPreview"
                                                        >
                                                          <div data-aura-rendered-by="2270:0">
                                                            <div
                                                              class="slds-card__body_inner forceContentFileDroppableZone forceContentRelatedListPreviewFileList"
                                                              data-aura-rendered-by="2284:0"
                                                              data-aura-class="forceContentFileDroppableZone forceContentRelatedListPreviewFileList"
                                                            >
                                                              <div
                                                                class="slds-file-selector slds-file-selector--integrated slds-file-selector--integrated"
                                                                data-aura-rendered-by="2285:0"
                                                              >
                                                                <div
                                                                  class="slds-file-selector__dropzone slds-file-selector__dropzone--integrated"
                                                                  data-aura-rendered-by="2286:0"
                                                                >
                                                                  <span
                                                                    class="slds-file-selector__body slds-file-selector__body--integrated"
                                                                    data-aura-rendered-by="2287:0"
                                                                  >
                                                                    <div
                                                                      icon-name="utility:upload"
                                                                      class="slds-icon-utility-upload slds-file-selector__body-icon slds-icon slds-icon-text-default slds-button__icon slds-icon_container forceIcon"
                                                                      data-data-rendering-service-uid="530"
                                                                      data-aura-rendered-by="2291:0"
                                                                      lwc-4897l11qtae-host=""
                                                                      data-aura-class="forceIcon"
                                                                    >
                                                                      <span
                                                                        lwc-4897l11qtae=""
                                                                        part="boundary"
                                                                      >
                                                                        <span
                                                                          lwc-4897l11qtae=""
                                                                          exportparts="icon"
                                                                          size="medium"
                                                                          variant="inverse"
                                                                          lwc-55d10h1nfm1-host=""
                                                                        >
                                                                          <svg
                                                                            focusable="false"
                                                                            aria-hidden="true"
                                                                            viewBox="0 0 520 520"
                                                                            part="icon"
                                                                            lwc-55d10h1nfm1=""
                                                                            data-key="upload"
                                                                            class="slds-icon"
                                                                          >
                                                                            <g lwc-55d10h1nfm1="">
                                                                              <path
                                                                                d="M485 310h-30c-8 0-15 8-15 15v100c0 8-7 15-15 15H95c-8 0-15-7-15-15V325c0-7-7-15-15-15H35c-8 0-15 8-15 15v135a40 40 0 0040 40h400a40 40 0 0040-40V325c0-7-7-15-15-15zM270 24c-6-6-15-6-21 0L114 159c-6 6-6 15 0 21l21 21c6 6 15 6 21 0l56-56c6-6 18-2 18 7v212c0 8 6 15 14 15h30c8 0 16-8 16-15V153c0-9 10-13 17-7l56 56c6 6 15 6 21 0l21-21c6-6 6-15 0-21z"
                                                                                lwc-55d10h1nfm1=""
                                                                              ></path>
                                                                            </g>
                                                                          </svg>
                                                                        </span>
                                                                      </span>
                                                                    </div>
                                                                    <span
                                                                      class="slds-file-selector__text slds-file-selector__text--integrated slds-text-heading--medium slds-text-align--center"
                                                                      data-aura-rendered-by="2292:0"
                                                                    >
                                                                      Drop Files
                                                                    </span>
                                                                  </span>
                                                                </div>
                                                                <div
                                                                  class="drag-over-body"
                                                                  data-aura-rendered-by="2294:0"
                                                                >
                                                                  <div
                                                                    variant="label-hidden"
                                                                    class="slds-form-element lightningInput"
                                                                    data-data-rendering-service-uid="531"
                                                                    data-aura-rendered-by="2274:0"
                                                                    lwc-66unc5l95ad-host=""
                                                                  >
                                                                    <div
                                                                      lwc-66unc5l95ad=""
                                                                      exportparts="button"
                                                                      variant="label-hidden"
                                                                      lwc-24ep20h9ret-host=""
                                                                    >
                                                                      <span
                                                                        lwc-24ep20h9ret=""
                                                                        class="slds-form-element__label slds-assistive-text"
                                                                        id="form-label-530"
                                                                        data-form-label=""
                                                                      >
                                                                        {" "}
                                                                      </span>
                                                                      <div
                                                                        lwc-24ep20h9ret=""
                                                                        class="slds-form-element__control"
                                                                      >
                                                                        <div
                                                                          lwc-24ep20h9ret=""
                                                                          class="slds-file-selector slds-file-selector--images slds-file-selector_images"
                                                                          part="file-selector"
                                                                        >
                                                                          <div
                                                                            lwc-24ep20h9ret=""
                                                                            class="slds-file-selector__dropzone"
                                                                            lwc-7gt6355bheb-host=""
                                                                          >
                                                                            <slot lwc-7gt6355bheb="">
                                                                              <label
                                                                                lwc-24ep20h9ret=""
                                                                                class="slds-file-selector__body"
                                                                                id="file-selector-label-530"
                                                                                data-file-selector-label=""
                                                                                for="input-file-530"
                                                                                aria-hidden="true"
                                                                              >
                                                                                <span
                                                                                  lwc-24ep20h9ret=""
                                                                                  class="slds-file-selector__button slds-button slds-button_neutral"
                                                                                  part="button"
                                                                                >
                                                                                  <span
                                                                                    lwc-24ep20h9ret=""
                                                                                    variant="bare"
                                                                                    lwc-55d10h1nfm1-host=""
                                                                                  >
                                                                                    <svg
                                                                                      focusable="false"
                                                                                      aria-hidden="true"
                                                                                      viewBox="0 0 520 520"
                                                                                      part="icon"
                                                                                      lwc-55d10h1nfm1=""
                                                                                      data-key="upload"
                                                                                      class="slds-button__icon slds-button__icon_left"
                                                                                    >
                                                                                      <g lwc-55d10h1nfm1="">
                                                                                        <path
                                                                                          d="M485 310h-30c-8 0-15 8-15 15v100c0 8-7 15-15 15H95c-8 0-15-7-15-15V325c0-7-7-15-15-15H35c-8 0-15 8-15 15v135a40 40 0 0040 40h400a40 40 0 0040-40V325c0-7-7-15-15-15zM270 24c-6-6-15-6-21 0L114 159c-6 6-6 15 0 21l21 21c6 6 15 6 21 0l56-56c6-6 18-2 18 7v212c0 8 6 15 14 15h30c8 0 16-8 16-15V153c0-9 10-13 17-7l56 56c6 6 15 6 21 0l21-21c6-6 6-15 0-21z"
                                                                                          lwc-55d10h1nfm1=""
                                                                                        ></path>
                                                                                      </g>
                                                                                    </svg>
                                                                                  </span>
                                                                                  Upload
                                                                                  Files
                                                                                </span>
                                                                                <span
                                                                                  class="slds-file-selector__text slds-medium-show"
                                                                                  lwc-24ep20h9ret=""
                                                                                >
                                                                                  Or
                                                                                  drop
                                                                                  files
                                                                                </span>
                                                                              </label>
                                                                            </slot>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="slds-hide"
                                                                    data-aura-rendered-by="2277:0"
                                                                  >
                                                                    <div
                                                                      data-aura-rendered-by="2278:0"
                                                                      lwc-qngrgp8qdv-host=""
                                                                    >
                                                                      <div
                                                                        class="body slds-grid slds-grid_vertical-align-center slds-p-around_large"
                                                                        lwc-qngrgp8qdv=""
                                                                      >
                                                                        <div
                                                                          class="slds-media__figure slds-avatar slds-m-right_small"
                                                                          lwc-qngrgp8qdv=""
                                                                        ></div>
                                                                        <div
                                                                          class="text-container"
                                                                          lwc-qngrgp8qdv=""
                                                                        >
                                                                          <div
                                                                            class="text slds-m-bottom_small"
                                                                            lwc-qngrgp8qdv=""
                                                                          ></div>
                                                                          <div
                                                                            class="text text-medium"
                                                                            lwc-qngrgp8qdv=""
                                                                          ></div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <ul
                                                                    class="uiAbstractList"
                                                                    data-aura-rendered-by="2:2123;a"
                                                                  ></ul>
                                                                  <div
                                                                    class="emptyContent hidden"
                                                                    data-aura-rendered-by="2280:0"
                                                                  >
                                                                    <div
                                                                      class="emptyContentInner slds-text-align_center slds-text-align--center"
                                                                      data-aura-rendered-by="2281:0"
                                                                    ></div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </article>
                                                </div>
                                              </div>
                                            </div>
                                          </slot>
                                        </div>
                                      </div>
                                    </div>
                                    <div lwc-77en8vud2tf="" class="listWrapper">
                                      <div
                                        lwc-77en8vud2tf=""
                                        lwc-1km0t387tm6-host=""
                                      >
                                        <div
                                          lwc-1km0t387tm6=""
                                          aria-busy="false"
                                          lwc-7ir4frst5a7-host=""
                                        >
                                          <slot lwc-7ir4frst5a7="">
                                            <div lwc-1km0t387tm6="">
                                              <div
                                                data-this-triggers-rerenders="[object Object]"
                                                class=""
                                              >
                                                <div
                                                  class="container forceRelatedListSingleContainer"
                                                  data-aura-rendered-by="2330:0"
                                                  data-aura-class="forceRelatedListSingleContainer"
                                                >
                                                  <article
                                                    class="slds-card slds-card_boundary slds-card_related-list-fix headerBottomBorder forceRelatedListCardDesktop"
                                                    aria-label="Stage History"
                                                    data-aura-rendered-by="2341:0"
                                                    data-aura-class="forceRelatedListCardDesktop"
                                                  >
                                                    <div
                                                      class="slds-grid slds-page-header forceRelatedListCardHeader"
                                                      data-aura-rendered-by="2349:0"
                                                      data-aura-class="forceRelatedListCardHeader"
                                                    >
                                                      <header
                                                        class="slds-media slds-media--center slds-has-flexi-truncate"
                                                        data-aura-rendered-by="2350:0"
                                                      >
                                                        <div
                                                          aria-hidden="true"
                                                          class="slds-m-right_small stencil slds-avatar slds-avatar_small"
                                                          data-aura-rendered-by="2351:0"
                                                        >
                                                          <div
                                                            class="extraSmall forceEntityIcon"
                                                            style={{
                                                              background:
                                                                "#06A59A",
                                                              width: "1.5rem",
                                                              height: "1.5rem",
                                                            }}
                                                            data-aura-rendered-by="2405:0"
                                                            data-aura-class="forceEntityIcon"
                                                          >
                                                            <span
                                                              data-aura-rendered-by="2408:0"
                                                              class="uiImage"
                                                              data-aura-class="uiImage"
                                                            >
                                                              <img
                                                                data-aura-rendered-by="2406:0"
                                                                src="/icons/standard/custom_120.png"
                                                                class="icon "
                                                                alt=""
                                                              />
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div
                                                          class="slds-media__body"
                                                          data-aura-rendered-by="2352:0"
                                                        >
                                                          <h2
                                                            id="header_2333:0"
                                                            class="slds-card__header-title"
                                                            data-aura-rendered-by="2353:0"
                                                          >
                                                            <a
                                                              href="/lightning/r/Opportunity/006QZ000002nOL0YAM/related/OpportunityHistories/view"
                                                              class="slds-card__header-link baseCard__header-title-container"
                                                              data-aura-rendered-by="2354:0"
                                                            >
                                                              <span
                                                                title="Stage History"
                                                                class="slds-truncate slds-m-right--xx-small"
                                                                data-aura-rendered-by="2355:0"
                                                              >
                                                                Stage History
                                                              </span>
                                                              <span
                                                                title="(1)"
                                                                class="slds-shrink-none slds-m-right--xx-small"
                                                                data-aura-rendered-by="2358:0"
                                                              >
                                                                (1)
                                                              </span>
                                                            </a>
                                                          </h2>
                                                        </div>
                                                      </header>
                                                      <div
                                                        class="slds-no-flex"
                                                        data-aura-rendered-by="2361:0"
                                                      >
                                                        <div
                                                          class="actionsContainer"
                                                          data-aura-rendered-by="2343:0"
                                                        >
                                                          <div
                                                            class="slds-float--right forceDeferredDropDownAction"
                                                            data-aura-rendered-by="2387:0"
                                                            data-aura-class="forceDeferredDropDownAction"
                                                          >
                                                            <a
                                                              role="button"
                                                              aria-haspopup="true"
                                                              class="slds-button slds-button_icon-small slds-button_icon-border-filled"
                                                              data-aura-rendered-by="2388:0"
                                                              href="javascript:void(0);"
                                                            >
                                                              <div
                                                                icon-name="utility:down"
                                                                class="slds-icon-utility-down slds-icon_container"
                                                                data-aura-rendered-by="2389:0"
                                                                lwc-4897l11qtae-host=""
                                                              >
                                                                <span
                                                                  lwc-4897l11qtae=""
                                                                  part="boundary"
                                                                >
                                                                  <span
                                                                    lwc-4897l11qtae=""
                                                                    exportparts="icon"
                                                                    size="xx-small"
                                                                    variant=""
                                                                    lwc-6qul4k2dv7m-host=""
                                                                  >
                                                                    <svg
                                                                      focusable="false"
                                                                      aria-hidden="true"
                                                                      viewBox="0 0 520 520"
                                                                      part="icon"
                                                                      lwc-6qul4k2dv7m=""
                                                                      data-key="down"
                                                                      class="slds-icon slds-icon-text-default slds-icon_xx-small"
                                                                    >
                                                                      <g lwc-6qul4k2dv7m="">
                                                                        <path
                                                                          d="M83 140h354c10 0 17 13 9 22L273 374c-6 8-19 8-25 0L73 162c-7-9-1-22 10-22z"
                                                                          lwc-6qul4k2dv7m=""
                                                                        ></path>
                                                                      </g>
                                                                    </svg>
                                                                  </span>
                                                                  <span
                                                                    class="slds-assistive-text"
                                                                    lwc-4897l11qtae=""
                                                                  >
                                                                    Show actions
                                                                    for Stage
                                                                    History
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </a>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div data-aura-rendered-by="2366:0">
                                                      <div
                                                        class=""
                                                        data-aura-rendered-by="2367:0"
                                                      >
                                                        <div
                                                          class="previewMode SMALL forceRelatedListPreview"
                                                          data-aura-rendered-by="2370:0"
                                                          data-aura-class="forceRelatedListPreview"
                                                        >
                                                          <div data-aura-rendered-by="2372:0">
                                                            <div
                                                              class="slds-card__body"
                                                              data-aura-rendered-by="2375:0"
                                                            >
                                                              <div
                                                                class="slds-hide"
                                                                data-aura-rendered-by="2378:0"
                                                              >
                                                                <div
                                                                  data-aura-rendered-by="2379:0"
                                                                  lwc-4auqus00epa-host=""
                                                                >
                                                                  <div
                                                                    class="slds-p-around_xxx-small"
                                                                    lwc-4auqus00epa=""
                                                                  >
                                                                    <div
                                                                      class="field"
                                                                      lwc-4auqus00epa=""
                                                                    >
                                                                      <div
                                                                        class="text text-primary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                      <div
                                                                        class="text text-secondary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                    </div>
                                                                    <div
                                                                      class="field"
                                                                      lwc-4auqus00epa=""
                                                                    >
                                                                      <div
                                                                        class="text text-primary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                      <div
                                                                        class="text text-secondary"
                                                                        lwc-4auqus00epa=""
                                                                      ></div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <ul
                                                                class="uiAbstractList"
                                                                data-aura-rendered-by="2:2251;a"
                                                              >
                                                                <li
                                                                  class="slds-var-p-horizontal_medium slds-var-p-vertical_xx-small desktop forceReadOnlyRelatedListStencil forceRecordLayout"
                                                                  data-aura-rendered-by="88:2251;a"
                                                                  data-aura-class="forceReadOnlyRelatedListStencil forceRecordLayout"
                                                                >
                                                                  <div data-aura-rendered-by="89:2251;a">
                                                                    <ul
                                                                      class="slds-truncate"
                                                                      data-aura-rendered-by="90:2251;a"
                                                                    >
                                                                      <li data-aura-rendered-by="92:2251;a">
                                                                        <div
                                                                          class="slds-list--horizontal forceListRecordItem"
                                                                          data-aura-rendered-by="14:2251;a"
                                                                          data-aura-class="forceListRecordItem"
                                                                        >
                                                                          <div
                                                                            title="Stage:"
                                                                            class="slds-item--label slds-truncate recordCell"
                                                                            data-aura-rendered-by="15:2251;a"
                                                                          >
                                                                            Stage:
                                                                          </div>
                                                                          <div
                                                                            class="slds-item--detail slds-truncate recordCell"
                                                                            data-aura-rendered-by="17:2251;a"
                                                                          >
                                                                            <span data-aura-rendered-by="11:2251;a">
                                                                              Perception
                                                                              Analysis
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </li>
                                                                      <li data-aura-rendered-by="94:2251;a">
                                                                        <div
                                                                          class="slds-list--horizontal forceListRecordItem"
                                                                          data-aura-rendered-by="25:2251;a"
                                                                          data-aura-class="forceListRecordItem"
                                                                        >
                                                                          <div
                                                                            title="Amount:"
                                                                            class="slds-item--label slds-truncate recordCell"
                                                                            data-aura-rendered-by="26:2251;a"
                                                                          >
                                                                            Amount:
                                                                          </div>
                                                                          <div
                                                                            class="slds-item--detail slds-truncate recordCell"
                                                                            data-aura-rendered-by="28:2251;a"
                                                                          >
                                                                            <span
                                                                              class="forceOutputCurrency"
                                                                              data-aura-rendered-by="22:2251;a"
                                                                              data-aura-class="forceOutputCurrency"
                                                                            >
                                                                              $0.00
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </li>
                                                                      <li data-aura-rendered-by="96:2251;a">
                                                                        <div
                                                                          class="slds-list--horizontal forceListRecordItem"
                                                                          data-aura-rendered-by="35:2251;a"
                                                                          data-aura-class="forceListRecordItem"
                                                                        >
                                                                          <div
                                                                            title="Probability (%):"
                                                                            class="slds-item--label slds-truncate recordCell"
                                                                            data-aura-rendered-by="36:2251;a"
                                                                          >
                                                                            Probability
                                                                            (%):
                                                                          </div>
                                                                          <div
                                                                            class="slds-item--detail slds-truncate recordCell"
                                                                            data-aura-rendered-by="38:2251;a"
                                                                          >
                                                                            <span
                                                                              data-aura-rendered-by="33:2251;a"
                                                                              class="uiOutputPercent"
                                                                              data-aura-class="uiOutputPercent"
                                                                            >
                                                                              70%
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </li>
                                                                      <li data-aura-rendered-by="98:2251;a">
                                                                        <div
                                                                          class="slds-list--horizontal forceListRecordItem"
                                                                          data-aura-rendered-by="45:2251;a"
                                                                          data-aura-class="forceListRecordItem"
                                                                        >
                                                                          <div
                                                                            title="Close Date:"
                                                                            class="slds-item--label slds-truncate recordCell"
                                                                            data-aura-rendered-by="46:2251;a"
                                                                          >
                                                                            Close
                                                                            Date:
                                                                          </div>
                                                                          <div
                                                                            class="slds-item--detail slds-truncate recordCell"
                                                                            data-aura-rendered-by="48:2251;a"
                                                                          >
                                                                            <span
                                                                              data-aura-rendered-by="43:2251;a"
                                                                              class="uiOutputDate"
                                                                              data-aura-class="uiOutputDate"
                                                                            >
                                                                              2/27/2025
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </li>
                                                                      <li data-aura-rendered-by="100:2251;a">
                                                                        <div
                                                                          class="slds-list--horizontal forceListRecordItem"
                                                                          data-aura-rendered-by="72:2251;a"
                                                                          data-aura-class="forceListRecordItem"
                                                                        >
                                                                          <div
                                                                            title="Last Modified By:"
                                                                            class="slds-item--label slds-truncate recordCell"
                                                                            data-aura-rendered-by="73:2251;a"
                                                                          >
                                                                            Last
                                                                            Modified
                                                                            By:
                                                                          </div>
                                                                          <div
                                                                            class="slds-item--detail slds-truncate recordCell"
                                                                            data-aura-rendered-by="75:2251;a"
                                                                          >
                                                                            <a
                                                                              data-refid="recordId"
                                                                              data-special-link="true"
                                                                              title="OrgFarm EPIC"
                                                                              data-navigable="true"
                                                                              target="_blank"
                                                                              data-ownerid="51:2251;a"
                                                                              data-recordid="005QZ000002D52LYAS"
                                                                              rel="noreferrer"
                                                                              href="/lightning/r/005QZ000002D52LYAS/view"
                                                                              class="outputLookupLink slds-truncate outputLookupLink-005QZ000002D52LYAS-51:2251;a forceOutputLookup"
                                                                              data-aura-rendered-by="62:2251;a"
                                                                              data-aura-class="forceOutputLookup"
                                                                            ></a>
                                                                          </div>
                                                                        </div>
                                                                      </li>
                                                                      <li data-aura-rendered-by="102:2251;a">
                                                                        <div
                                                                          class="slds-list--horizontal forceListRecordItem"
                                                                          data-aura-rendered-by="82:2251;a"
                                                                          data-aura-class="forceListRecordItem"
                                                                        >
                                                                          <div
                                                                            title="Last Modified:"
                                                                            class="slds-item--label slds-truncate recordCell"
                                                                            data-aura-rendered-by="83:2251;a"
                                                                          >
                                                                            Last
                                                                            Modified:
                                                                          </div>
                                                                          <div
                                                                            class="slds-item--detail slds-truncate recordCell"
                                                                            data-aura-rendered-by="85:2251;a"
                                                                          >
                                                                            <span
                                                                              data-aura-rendered-by="80:2251;a"
                                                                              class="uiOutputDateTime"
                                                                              data-aura-class="uiOutputDateTime"
                                                                            >
                                                                              2/11/2025,
                                                                              3:49
                                                                              AM
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </li>
                                                                    </ul>
                                                                  </div>
                                                                </li>
                                                              </ul>
                                                              <div
                                                                class="emptyContent hidden"
                                                                data-aura-rendered-by="2381:0"
                                                              >
                                                                <div
                                                                  class="emptyContentInner slds-text-align_center slds-text-align--center"
                                                                  data-aura-rendered-by="2382:0"
                                                                ></div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <a
                                                      href="/lightning/r/Opportunity/006QZ000002nOL0YAM/related/OpportunityHistories/view"
                                                      data-aura-rendered-by="2397:0"
                                                    >
                                                      <div
                                                        class="slds-card__footer"
                                                        data-aura-rendered-by="2398:0"
                                                      >
                                                        <span
                                                          class="view-all-label"
                                                          data-aura-rendered-by="2399:0"
                                                        >
                                                          View All
                                                          <span
                                                            class="assistiveText"
                                                            data-aura-rendered-by="2401:0"
                                                          >
                                                            Stage History
                                                          </span>
                                                        </span>
                                                      </div>
                                                    </a>
                                                  </article>
                                                </div>
                                              </div>
                                            </div>
                                          </slot>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <force-version-marker lwc-77en8vud2tf=""></force-version-marker>
                                </div>
                              </slot>
                            </div>
                          </slot>
                        </div>
                      </slot>
                    </slot>
                  </div>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </slot>
    </div>
  </div>
);
